import React, { Component, Fragment } from "react";
import Helmet from "react-helmet";
import { Link } from "react-router-dom";
import { Prompt } from "react-router";

import { connect } from "react-redux";

import { Can } from "constants/abilityContext";
import {
  COMPLIANCE_STATUS_ACCEPT,
  COMPLIANCE_STATUS_DENY,
  COMPLIANCE_STATUS_LIST,
  COMPLIANCE_FIELDS_LIST,
} from "constants/dbValues";
import { icons } from "constants/icons";
import {
  history,
  title,
  isChecked,
  validateProfileFields,
  selectProps,
  displayErrorContext,
  renderProjectSelectOption,
} from "utils";

import { Header } from "components";
import { Icon, Input, notification, Button, Checkbox, Select, Spin } from "antd";

import { complianceService, projectService, selectService } from "services";

// Composant de détails d'un modèle.
// Beaucoup d'optimisation possible (React Modeling 04h11 pour code optimisé et centralisé).
//
// Les fonctions suivantes sont implémentées :
// - fetchSelects()
//   Fetch les options des dropdowns avec le selectService.
// - formatTag()
//   Render le html approprié selon les clés données dans le html.
//   En read render du static, en edit ou create render des inputs.
// - handleChange()
//   Gère le changement d'une valeur.
// - handleSubmit()
//   Gère le submit du form, tant en edit qu'en create.
// - validateFields()
//   Valide les champs du form qui sont required, utilise la fonction validateProfileFields
//   de utils/form.
// - render()
//   Render commun pour les 3 modes, la gestion des inputs se fait dans
//   formatTag(), mais les conditions plus générales se font directement dans render()
class NotePage extends Component {
  constructor(props) {
    super(props);

    const { id } = this.props.match.params;
    const { type } = this.props;

    this.state = {
      note: {
        __type: "Compliance",
        id: id,
        status: 1,
        compliance_type_id: type,
      },
      uploading: false,
      errors: {},
      edited: false,
      types: [],
      projects: [],
      path: "notes",
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validateFields = this.validateFields.bind(this);
  }

  componentDidMount() {
    const { note, path } = this.state;
    const { edit, create } = this.props;

    if (!create) {
      complianceService
        .get(note.id)
        .then((result) => {
          this.setState({ note: { ...note, ...result } });
        })
        .catch((e) => {
          history.push("/" + path);
        });
    }

    if (edit || create) this.fetchSelects();
  }

  componentWillReceiveProps(nextProps) {
    const { types } = this.state;
    const { edit, create } = nextProps;
    if ((!types || types.length === 0) && (edit || create)) this.fetchSelects();
  }

  async fetchSelects() {
    const selects = await selectService.listForPage("compliance");
    const projects = await projectService.list({
      order_by: "code,label",
      order_direction: "ASC,ASC",
      disabled: 0,
    });

    this.setState({ types: selects.ComplianceType, projects });
  }

  formatTag(key, fixed = false, label = "") {
    const { note, errors } = this.state;
    const { edit, create } = this.props;
    const noteData = { ...note }; // avoids undesirable state modification

    if ((!edit && !create) || (fixed && edit)) {
      if (key === "description" && note[key])
        noteData[key] = noteData[key].split("\n").map((item, key) => (
          <Fragment key={key}>
            {item}
            <br />
          </Fragment>
        ));

      switch (key) {
        case "compliance_type_id":
          return note.compliance_type ? (
            <>
              <Icon type="tag" />
              {note.compliance_type.label}
            </>
          ) : (
            ""
          );
        case "project_id":
          return note.project ? (
            <Link to={`/projects/${note.project_id}`}>
              <Icon type={icons.project} />
              {`${note.project.label}`}
            </Link>
          ) : (
            ""
          );
        case "status":
          return note[key] != null ? (
            <>
              <Icon
                type={
                  Number(note[key]) === COMPLIANCE_STATUS_DENY ? "close-circle" : "check-circle"
                }
              />
              {COMPLIANCE_STATUS_LIST.find((s) => s.id === Number(note[key])).label}
            </>
          ) : (
            ""
          );
        case "user_name":
          return note.user ? (
            <b>
              {(note.user || {}).name} {(note.user || {}).surname}
            </b>
          ) : (
            <b></b>
          );
        case "cost":
          return <b>{`${Number(note[key]) / 100}$`}</b>;
        default:
          return <b>{note[key]}</b>;
      }
    }

    let input;
    let fieldIndex = COMPLIANCE_FIELDS_LIST.findIndex((f) => f.name === key);
    if (fieldIndex > -1) {
      let field = COMPLIANCE_FIELDS_LIST[fieldIndex];
      if (field.options) {
        input = (
          <Select
            value={note[key]}
            onChange={(value) => this.handleChange(value, key)}
            {...selectProps()}
          >
            {React.Children.toArray(
              field.options.map((t) => <Select.Option value={t.id}>{t.label}</Select.Option>),
            )}
          </Select>
        );
      } else {
        let Tag = field.multiline ? Input.TextArea : Input;
        let inputProps = field.multiline ? { autoSize: { minRows: 3, maxRows: 20 } } : null;
        input = (
          <Tag
            name={key}
            value={
              field.getInputValue
                ? note[key] != null
                  ? field.getInputValue(note[key])
                  : ""
                : note[key]
            }
            type={field.type || "text"}
            {...inputProps}
            onChange={(e) => this.handleChange(e.target.value, key)}
          />
        );
      }
    } else if (key === "compliance_type_id" || key === "project_id") {
      var list = [],
        computeLabel = (t) => t.label;
      if (key === "compliance_type_id") {
        list = this.state.types;
      }
      if (key === "project_id") {
        list = this.state.projects;
        computeLabel = renderProjectSelectOption;
      }

      var options = list.map((t) => (
        <Select.Option key={t.id} value={t.id}>
          {computeLabel(t)}
        </Select.Option>
      ));

      input = (
        <Select
          value={note[key]}
          onChange={(value) => this.handleChange(value, key)}
          {...selectProps()}
        >
          {options}
        </Select>
      );
    } else {
      var Tag = key === "description" ? Input.TextArea : Input;
      let inputProps = key === "description" ? { autoSize: { minRows: 3, maxRows: 20 } } : null;
      input = (
        <Tag
          name={key}
          value={note[key]}
          {...inputProps}
          onChange={(e) => this.handleChange(e.target.value, key)}
        />
      );
    }

    var error = errors && errors[key];
    return <span className={error ? "error-wrap" : ""}>{input}</span>;
  }

  handleChange(value, key) {
    let fieldIndex = COMPLIANCE_FIELDS_LIST.findIndex((f) => f.name === key);
    let field = fieldIndex > -1 ? COMPLIANCE_FIELDS_LIST[fieldIndex] : null;
    this.setState({
      note: {
        ...this.state.note,
        [key]: field?.getSubmitValue ? field.getSubmitValue(value) : value,
      },
      edited: true,
    });
  }

  handleSubmit() {
    if (!this.validateFields()) return;

    var note = { ...this.state.note };
    const { path } = this.state;
    const { edit, create } = this.props;

    var func;
    // for (let i=0; i < COMPLIANCE_FIELDS_LIST.length; ++i){
    //     let field = COMPLIANCE_FIELDS_LIST[i]
    //     note[field.name] = field.getSubmitValue ? field.getSubmitValue(note[field.name]) : note[field.name]
    // }

    if (edit) {
      func = complianceService.update;
    } else if (create) {
      func = complianceService.create;
      note.date = new Date();
      note.user_id = this.props.user.id;
    }

    if (!note.status) note.status = COMPLIANCE_STATUS_ACCEPT;

    this.setState({ uploading: true }, () => {
      func(note)
        .then((n) => {
          notification.open({
            message: "Enregistrement effectué",
            description: "Vos changements ont été enregistrés avec succès.",
            placement: "bottomRight",
          });

          this.setState({ note: { ...note, ...n }, edited: false, uploading: false });
          history.replace(`/${path}/${n.id}`);
        })
        .catch((e) => {
          this.setState({ uploading: false });
          notification.open({
            message: "Une erreur s'est produite",
            description: "Veuillez réessayer ou contacter un administrateur.",
            placement: "bottomRight",
          });
        });
    });
  }

  validateFields() {
    const { note } = this.state;
    const { edit, create } = this.props;

    var fields = [
      "project_id",
      "compliance_type_id",
      "description",
      ...COMPLIANCE_FIELDS_LIST.map((f) => f.name),
    ];
    var validation = validateProfileFields(note, fields);

    this.setState({ errors: validation.errors });
    return !validation.hasError;
  }

  render() {
    const { note, errors, path, uploading } = this.state;
    const { edit, create } = this.props;

    var term = "non-conformité",
      directPrefix = "la ";
    //    contentLabel = 'Description de la NC, de la localisation, des matériaux et de la main d’œuvre pour traiter celle-ci :'
    var mode = "read",
      pageTitle = `Détails d'une ${term}`,
      header = `${term[0].toUpperCase() + term.slice(1)} #NC-${note.id}`,
      bread = [{ to: `/${path}`, text: `Liste des ${term}s` }, { text: note.id }];

    if (edit) {
      mode = "edit";
      pageTitle = `Édition d'une ${term}`;
      bread = [
        { to: `/${path}`, text: `Liste des ${term}s` },
        { to: `/${path}/${note.id}`, text: note.id },
        { text: "Édition" },
      ];
    } else if (create) {
      mode = "create";
      pageTitle = `Création d'une ${term}`;
      header = `Nouvelle ${term}`;
      bread = [{ to: `/${path}`, text: `Liste des ${term}s` }, { text: "Création" }];
    }

    return (
      <Fragment>
        <Helmet>{title(pageTitle)}</Helmet>

        <Header title={header} bread={bread} />

        <div className={`note-page main-content profile-content ${mode}`}>
          <Can do={mode} on={note}>
            <Spin
              indicator={<Icon type="loading" spin style={{ fontSize: "52px" }} />}
              spinning={uploading}
            >
              {mode === "read" && (
                <ul className="tags">
                  <li>{this.formatTag("project_id")}</li>
                  <li className="alt">{this.formatTag("compliance_type_id")}</li>
                  <li className="alt">{this.formatTag("status")}</li>
                </ul>
              )}

              <ul className={"profile-main-content " + mode}>
                {mode === "create" ? (
                  <li>
                    <label>Projet :</label>
                    {this.formatTag("project_id", true)}
                  </li>
                ) : (
                  <li>
                    <label style={{ marginRight: 6 }}>Créée par :</label>
                    {this.formatTag("user_name", true)}
                  </li>
                )}

                {mode === "read" ? (
                  <li>
                    <label style={{ marginRight: 6 }}>Numéro séquentiel :</label>
                    {this.formatTag("id", true)}
                  </li>
                ) : (
                  <></>
                )}

                {React.Children.toArray(
                  COMPLIANCE_FIELDS_LIST.filter((f) => f.name !== "status").map((f) => (
                    <li className="note-content">
                      <label>{f.label} :</label>
                      {this.formatTag(f.name)}
                    </li>
                  )),
                )}

                {mode !== "read" && (
                  <Fragment>
                    <li>
                      <label>Type :</label>
                      {this.formatTag("compliance_type_id")}
                    </li>
                    <li>
                      <label>Statut</label>
                      {this.formatTag("status")}
                    </li>
                  </Fragment>
                )}
              </ul>

              {(edit || create) && (
                <Fragment>
                  {displayErrorContext(errors)}

                  <div className="buttons">
                    <Button type="link" onClick={() => history.goBack()}>
                      Annuler
                    </Button>
                    <Button
                      type="primary"
                      disabled={edit && !this.state.edited}
                      onClick={() => this.handleSubmit()}
                    >
                      {edit ? "Enregistrer les changements" : `Créer ${directPrefix}${term}`}
                    </Button>
                  </div>

                  <Prompt
                    when={this.state.edited}
                    message="Attention, certaines de vos modifications n'ont pas été enregistrées. Voulez-vous vraiment quitter cette page ?"
                  />
                </Fragment>
              )}

              {!edit && !create && (
                <div className="buttons">
                  <Button type="primary" onClick={() => history.push(`/${path}/${note.id}/edit`)}>
                    Éditer {directPrefix}
                    {term}
                  </Button>
                </div>
              )}
            </Spin>
          </Can>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.infos || {},
  };
};

export default connect(mapStateToProps, null)(NotePage);
